import { render, staticRenderFns } from "./ItemsQuotationList.vue?vue&type=template&id=144e1b83&scoped=true"
import script from "./ItemsQuotationList.vue?vue&type=script&lang=js"
export * from "./ItemsQuotationList.vue?vue&type=script&lang=js"
import style0 from "./ItemsQuotationList.vue?vue&type=style&index=0&id=144e1b83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e1b83",
  null
  
)

export default component.exports